(() => {
  const bindFilms = (scope = document) => {
    scope.querySelectorAll('[data-fm-film]').forEach((button) => {
      if (button.dataset.bound) return;
      const dialog = document.getElementById(button.dataset.fmFilm);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const video = dialog.querySelector('video');
      button.dataset.bound = 'true';
      button.hidden = false;
      button.addEventListener('click', () => {
        dialog.showModal();
        document.dispatchEvent(new CustomEvent('fm:interaction', {detail: {name: 'fm_campaign_play'}}));
        video?.play().catch(() => {});
      });
      dialog.querySelector('[data-fm-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }
      });
      dialog.addEventListener('close', () => { video?.pause(); button.focus(); });
    });
  };
  bindFilms();
  document.addEventListener('shopify:section:load', (event) => bindFilms(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('video').forEach(video => video.pause()));

  if (!customElements.get('fm-sticky-buy')) customElements.define('fm-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.control = this.querySelector('[data-fm-sticky-button]');
      this.price = this.querySelector('[data-fm-sticky-price]');
      this.info = document.getElementById(`ProductInfo-${this.dataset.section}`);
      if (!this.info || !this.control) return;
      this.original = this.info.querySelector('product-form button[name="add"]');
      if (!this.original) return;
      this.onClick = () => {
        const root = this.info.closest('product-info');
        if (root?.fmMissingChoice?.()) {
          root.fmFocusChoice();
        } else {
          this.original.click();
          const error = this.info.querySelector('.product-form__error-message-wrapper');
          if (error && !error.hidden) error.scrollIntoView({ block: 'center' });
        }
      };
      this.control.addEventListener('click', this.onClick);
      this.observer = new IntersectionObserver(entries => { this.hidden = entries[0].isIntersecting; }, { rootMargin: '-100px 0px 0px 0px' });
      this.observer.observe(this.original);
      this.sync = () => {
        this.original = this.info.querySelector('product-form button[name="add"]');
        if (!this.original) { this.hidden = true; return; }
        this.control.disabled = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true';
        this.control.textContent = this.original.querySelector('span')?.textContent.trim();
        const selection = Array.from(this.info.querySelector('variant-selects')?.querySelectorAll('[data-fm-required-choice]') || []).map(group => group.querySelector('input:checked')?.value).filter(Boolean);
        const choiceText = this.querySelector('[data-fm-sticky-selection]');
        if (choiceText) choiceText.textContent = selection.join(' / ');
        const currentPrice = this.info.querySelector('.price:not(.hidden) .price-item--sale') || this.info.querySelector('.price-item--regular');
        const priceRoot = this.info.querySelector('.price');
        const activePrice = priceRoot?.classList.contains('price--on-sale') ? currentPrice : this.info.querySelector('.price__regular .price-item--regular');
        const selectionTotal = this.info.querySelector("[data-fm-selection-total]");
        if (selectionTotal || activePrice) this.price.textContent = (selectionTotal || activePrice).textContent.trim();
        const error = this.info.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (error && !this.hidden) { this.hidden = true; error.scrollIntoView({ block: 'center' }); }
      };
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden', 'class', 'checked'] });
      this.sync();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.mutations?.disconnect(); this.control?.removeEventListener('click', this.onClick); }
  });
})();

